import { render, staticRenderFns } from "./EcCalendar.vue?vue&type=template&id=671c8025&scoped=true&"
import script from "./EcCalendar.vue?vue&type=script&lang=ts&"
export * from "./EcCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./EcCalendar.vue?vue&type=style&index=0&id=671c8025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c8025",
  null
  
)

export default component.exports